
import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import './PageContent.css'

const PageContent = props => {
  const { children, isFluid } = props
  const classes = classnames({
    PageContent: true,
    'PageContent--isFluid': isFluid
  })
  return (
    <div className={classes}>
      {children}
    </div>
  )
}

PageContent.displayName = 'PageContent'

PageContent.propTypes = {
  children: PropTypes.oneOfType([ PropTypes.array, PropTypes.object ]).isRequired,
  isFluid: PropTypes.bool
}

export default PageContent



// WEBPACK FOOTER //
// ./ui/PageContent.js